/**
 *
 * Asynchronously loads the component for Admin
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AdminPage = lazyLoad(
  () => import('./index'),
  module => module.AdminPage,
);
